import { visit } from 'unist-util-visit';
/**
 * Keyboard access to the boxes that scroll sideways (WCAG 2.1.1).
 *
 * A wide table and a long code line each get their own horizontal scroll box on
 * the published site — the table's from Starlight's stylesheet, the code's from
 * Expressive Code — and NEITHER was reachable with a keyboard. A mouse can drag
 * them; a keyboard cannot put focus in them, so half of a ten-column rate-limit
 * table simply did not exist for anybody who does not use a mouse. axe calls it
 * `scrollable-region-focusable`; the reader calls it a missing column.
 *
 * `tabindex="0"` on the element that actually scrolls, rather than a wrapper
 * around it: the scroll box belongs to somebody else's stylesheet, and a wrapper
 * would have to take the overflow off theirs to become the scroller. This adds
 * an attribute and changes no layout.
 *
 * Applied to every table and every code block, because a build cannot know which
 * ones will be too wide — that depends on the reader's screen. The cost is a tab
 * stop on a narrow table; the alternative is a column nobody can reach.
 *
 * Not given `role="region"` or a label: the axe rule asks for focus, and a
 * landmark per table would announce "region" on every table in a reference.
 */
export function rehypeScrollableRegions() {
    return (tree) => {
        visit(tree, 'element', (node) => {
            if (node.tagName !== 'table' && node.tagName !== 'pre')
                return;
            node.properties = node.properties ?? {};
            // Never overwrite one: Expressive Code sets its own on some versions, and
            // an author writing raw HTML may have made a considered choice.
            if (node.properties['tabIndex'] === undefined && node.properties['tabindex'] === undefined) {
                node.properties['tabIndex'] = 0;
            }
        });
    };
}
//# sourceMappingURL=scrollable.js.map